export default __webpack_public_path__ + "static/media/Group 1691@2x.ad3c0522.png";